import './review.scss';
import '../product-details.scss';

export default class ReviewCtrl {

    // @ngInject
    constructor(signupDataStore, responseHandler, OrderResource, countryData, stripeConfig, PaymentProfileResource, $q) {

        this.$loading = true;
        this.responseHandler = responseHandler;
        this.signupDataStore = signupDataStore;
        this.OrderResource = OrderResource;
        this.stripeConfig = stripeConfig;


        this.account = angular.copy(signupDataStore.account);
        this.payment = angular.copy(signupDataStore.payment) || {};
        this.stripe = angular.copy(signupDataStore.stripe) || {};

        // clear the data from global store
        signupDataStore.payment = {};
        signupDataStore.stripe = {};

        responseHandler(countryData.query().$promise, 'fetching countries')
            .then((countries) => this.countries = countries);

        let promises = {};

        if (this.stripe.card === undefined) {
            let payProfile = PaymentProfileResource.getProfile().$promise;
            promises.payProfile = this.responseHandler(payProfile, 'Fetching card details');
        }

        if (this.signupDataStore.invoice === null || this.signupDataStore.invoice === undefined) {
            let checkout = this.OrderResource.checkout({
                product_id: this.signupDataStore.upgrade.plan.id
            });
            promises.order = this.responseHandler(checkout.$promise, 'creating an order');
        }

        $q.all(promises).then((data) => {
            if (data.payProfile) {
                this.stripe.card = data.payProfile.cards[0];
            }

            if (data.order) {
                this.signupDataStore.invoice = data.order.invoice;
            }
            return data;
        })
        .then(() => {
            this.calculateTax().then( (data) => {
                this.tax = data;
                this.fetchOrderForUserCountry();
            });
        });
    }

    calculateTax() {
        let meta = this.payment.metadata || {};
        let taxData = {
            invoice_number: this.signupDataStore.invoice,
            address_country: this.stripe.card.address_country,
            address_state: this.stripe.card.address_state,
            user_type: meta.is_company ? 'business' : 'consumer',
            vat_number: meta.is_company ? meta.vat_number : null
        };

        return this.OrderResource.calculateTax(taxData).$promise;
    }


    fetchOrderForUserCountry() {
        let order = this.OrderResource.order({
            invoice: this.signupDataStore.invoice
        });

        this.responseHandler(order.$promise, 'fetching your order')
            .then((data) => this.setOrderData(data));
    }

    setOrderData(data) {
        this.currency = data.order.currency;
        this.cur = data.order.currency.symbol + '\u2008'; // &puncsp;
        this.order = angular.extend(data.order, this.tax);
        this.price = data.total_price;
        this.$loading = false;
    }

    charge() {
        let meta = this.payment.metadata || {};

        let order = this.OrderResource.charge({
            store_source: false,
            card_details: {
                token_id: this.stripe.id
            },
            invoice: this.signupDataStore.invoice,
            vat_number: meta.is_company ? meta.vat_number : undefined,
            company_name: meta.is_company ? meta.company_name : undefined
        });

        this.responseHandler(order.$promise, 'placing your order').then(() => {
            this.confirm();
        }, () => {
            this.failure();
        });
    }

    changePayment() {
        this.signupDataStore.upgrade.stage = 'payment';
    }

    confirm() {
        this.signupDataStore.upgrade.stage = 'confirmation';
    }

    failure() {
        this.signupDataStore.upgrade.stage = 'failure';
    }

}



// WEBPACK FOOTER //
// ./payments/review/review-ctrl.js